import React from 'react';
import { MessageSquare, Mail, Phone, Calendar, User, ShieldCheck, FileImage } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { API_BASE_URL } from "../../services/api";

export default function PlainteDetailsView({ tr }) {
  if (!tr) return null;

  const user = tr.user;
  
  const userAvatar = user?.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${user.profilPicture}`
    : defaultAvatar;
  
  const complaintImage = tr.file 
    ? `${API_BASE_URL.replace("/api", "")}/images/complaints/${tr.file}`
    : null;

  return (
    <div className="tripCard modern pageMode">
      <div className="tripTop">
        <div className="headerWithIcon" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <div className="headerIcon" style={{ background: 'rgba(214, 166, 42, 0.1)', padding: '10px', borderRadius: '12px' }}>
            <MessageSquare size={32} color="#D6A62A" />
          </div>
          <div>
            <div className="tripId">Sujet : {tr.subject}</div>
            <div className="tripDate">Reçue le : {new Date(tr.created_at).toLocaleString("fr-FR")}</div>
          </div>
        </div>
        <div className="tripRight">
          <div className={`statusBadge ${tr.id_status === 'S03' ? 'S03' : 'S01'}`}>
            {tr.status?.name || tr.id_status}
          </div>
        </div>
      </div>

      <div className="tripGrid">
        <div className="leftColumn">
          {/* Bloc Description */}
          <div className="tripBlock">
            <div className="blockTitle">Détails de la réclamation</div>
            <div className="contentBox" style={{ padding: '1.5rem', background: '#f8fafc', borderRadius: '12px', border: '1px solid #edf2f7' }}>
              <p style={{ lineHeight: '1.7', color: '#334155', whiteSpace: 'pre-wrap', fontSize: '1.05rem' }}>
                {tr.message}
              </p>
            </div>
          </div>
          
          <div className="tripBlock">
            <div className="blockTitle">Fichier joint / Preuve</div>
            {complaintImage ? (
              <div className="complaintImageContainer" style={{ marginTop: '10px' }}>
                <img 
                  src={complaintImage} 
                  alt="Preuve plainte" 
                  style={{ 
                    width: '100%', 
                    maxHeight: '400px', 
                    objectFit: 'contain', 
                    borderRadius: '12px',
                    border: '1px solid #eee',
                    background: '#f9f9f9'
                  }} 
                  onError={(e) => { e.target.src = "https://placehold.co/600x400?text=Image+non+disponible"; }}
                />
              </div>
            ) : (
              <div style={{ 
                padding: '20px', 
                textAlign: 'center', 
                background: '#f9f9f9', 
                borderRadius: '12px', 
                color: '#94a3b8',
                border: '2px dashed #eee'
              }}>
                <FileImage size={32} style={{ marginBottom: '10px', opacity: 0.5 }} />
                <p>Aucune image jointe à cette plainte</p>
              </div>
            )}
          </div>
        </div>

        <div className="rightColumn">
          <div className="tripBlock">
            <div className="blockTitle">Client émetteur</div>
            <div className="modernUserCard">
              <img src={userAvatar} className="modernAvatar" alt="client" />
              <div>
                <div className="modernUserName">{user?.firstName} {user?.lastName}</div>
                <div className="modernUserRole">@{user?.username || "client"}</div>
              </div>
            </div>
            
            <div className="infoList" style={{ marginTop: '1.5rem', borderTop: '1px solid #f1f5f9', paddingTop: '1rem' }}>
              <InfoItem icon={<Phone size={16} />} label="Téléphone" value={user?.contact?.tel} />
              <InfoItem icon={<Calendar size={16} />} label="Compte créé le" value={user?.created_at ? new Date(user.created_at).toLocaleDateString() : "-"} />
              <InfoItem icon={<ShieldCheck size={16} />} label="ID Client" value={user?.id?.split('-')[0]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoItem({ icon, label, value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
      <div style={{ color: '#94a3b8' }}>{icon}</div>
      <div>
        <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</div>
        <div style={{ fontWeight: '600', color: '#1e293b' }}>{value || "-"}</div>
      </div>
    </div>
  );
}